export default __webpack_public_path__ + "static/media/Group 8706_5.16f2fb66.png";